// extracted by mini-css-extract-plugin
export default {"root":"FlowSurvey_root__sRZ-X","hidden":"FlowSurvey_hidden__ciZCI"};